import type { RouteMap } from '@/scripts/router/types';
import { genRoutesMap } from '@/scripts/router';
import App from '@/App';
import Login from '@/pages/login';
import Main from '@/pages/main';
import Calls from '@/pages/calls';
import Messages from '@/pages/messages';
import Feeds from '@/pages/feeds';
import Shorts from '@/pages/shorts';
import User from '@/pages/user';
import Wallet from '@/pages/wallet';
import AuthCallback from '@/pages/login/auth-callback';
import Contacts from '@/pages/contacts';
import Settings from '@/pages/settings';
import { routeMap } from './routeMap';
import Paths from './paths';
import { ErrorBoundary } from './ErrorBoundary';

// Configure the element here separately to avoid load order problems when reading menu data
export const routeMapRuntime: RouteMap = genRoutesMap(
  {
    [Paths.BASE]: {
      element: <App></App>,
      ErrorBoundary: ErrorBoundary,
    },
    [Paths.LOGIN]: {
      element: <Login></Login>,
    },
    [Paths.AUTH_CALLBACK]: {
      element: <AuthCallback></AuthCallback>,
    },
    [Paths.MAIN]: {
      element: <Main></Main>,
    },
    [Paths.CALLS]: {
      element: <Calls></Calls>,
    },
    [Paths.MESSAGES_PATH]: {},
    [Paths.MESSAGES]: {
      element: <Messages></Messages>,
    },
    [Paths.MESSAGES_CHATS]: {},
    [Paths.MESSAGES_UNREAD]: {},
    [Paths.FEEDS]: {
      element: <Feeds></Feeds>,
    },
    [Paths.SHORTS]: {
      element: <Shorts></Shorts>,
    },
    [Paths.User]: {
      element: <User></User>,
    },
    [Paths.Wallet]: {
      element: <Wallet></Wallet>,
    },
    [Paths.CONTACTS]: {
      element: <Contacts></Contacts>,
    },
    [Paths.SETTINGS_PATH]: {},
    [Paths.SETTINGS]: {
      element: <Settings></Settings>,
    },
    [Paths.SETTINGS_NOTIFICATIONS]: {},
    [Paths.SETTINGS_SECURITY]: {},
    [Paths.SETTINGS_PRIVACY]: {},
    [Paths.SETTINGS_ABOUT]: {},
  },
  routeMap
);
